import { NavLink } from 'react-router-dom';

interface NavItem {
  to: string;
  icon: string;
  label: string;
}

const memoryNav: NavItem[] = [
  { to: '/memory', icon: '💾', label: 'Memory Items' },
  { to: '/code-graph', icon: '🔗', label: 'Code Graph' },
  { to: '/memory-agents', icon: '🤖', label: 'Memory Agents' },
  { to: '/benchmarks', icon: '📈', label: 'Benchmarks' },
  { to: '/services', icon: '⚙️', label: 'Memory Services' },
];

const orchNav: NavItem[] = [
  { to: '/workflows', icon: '🔀', label: 'Workflows' },
  { to: '/editor', icon: '✏️', label: 'Workflow Editor' },
  { to: '/dlq', icon: '📋', label: 'Dead Letter Queue' },
  { to: '/agent-config', icon: '🤖', label: 'Agent Config' },
  { to: '/schedules', icon: '📅', label: 'Schedules' },
  { to: '/metrics', icon: '📈', label: 'Metrics' },
];

const systemNav: NavItem[] = [
  { to: '/architecture', icon: '🏗️', label: 'Architecture' },
  { to: '/repository', icon: '🔀', label: 'Repository' },
  { to: '/settings', icon: '⚙️', label: 'Settings' },
];

function NavSection({ title, items }: { title: string; items: NavItem[] }) {
  return (
    <div className="nav-section">
      <div style={{
        fontSize: 10, fontWeight: 600, textTransform: 'uppercase',
        letterSpacing: '1px', color: 'var(--text-3)', padding: '16px 16px 6px',
      }}>
        {title}
      </div>
      {items.map(item => (
        <NavLink
          key={item.to}
          to={item.to}
          className={({ isActive }) =>
            `nav-link ${isActive ? 'active' : ''}`
          }
        >
          <span className="nav-icon">{item.icon}</span>
          <span>{item.label}</span>
        </NavLink>
      ))}
    </div>
  );
}

export default function Sidebar() {
  return (
    <aside style={{
      width: 'var(--sidebar-width)',
      height: '100vh',
      background: 'var(--bg-1)',
      borderRight: '1px solid var(--border)',
      display: 'flex',
      flexDirection: 'column',
      position: 'fixed',
      left: 0,
      top: 0,
      zIndex: 50,
      overflow: 'hidden',
    }}>
      {/* Logo */}
      <div style={{
        padding: '20px 16px 12px',
        borderBottom: '1px solid var(--border)',
      }}>
        <div style={{ fontSize: 18, fontWeight: 700, color: 'var(--accent)' }}>
          🧠 OpenClaw
        </div>
        <div style={{ fontSize: 11, color: 'var(--text-2)', marginTop: 2 }}>
          Control Panel
        </div>
      </div>

      {/* Navigation */}
      <nav style={{ flex: 1, overflowY: 'auto', paddingBottom: 20 }}>
        <div style={{ padding: '8px 8px 0' }}>
          <NavLink
            to="/"
            end
            className={({ isActive }) => `nav-link ${isActive ? 'active' : ''}`}
          >
            <span className="nav-icon">📊</span>
            <span>Overview</span>
          </NavLink>
        </div>

        <NavSection title="Memory System" items={memoryNav} />
        <NavSection title="Orchestration" items={orchNav} />
        <NavSection title="System" items={systemNav} />
      </nav>

      <style>{`
        .nav-link {
          display: flex;
          align-items: center;
          gap: 10px;
          padding: 8px 12px;
          margin: 1px 8px;
          border-radius: 6px;
          color: var(--text-1);
          font-size: 13px;
          font-weight: 500;
          text-decoration: none;
          transition: all 0.15s;
        }
        .nav-link:hover {
          background: var(--bg-2);
          color: var(--text-0);
          text-decoration: none;
        }
        .nav-link.active {
          background: rgba(59, 130, 246, 0.12);
          color: var(--accent);
          border: 1px solid rgba(59, 130, 246, 0.2);
        }
        .nav-icon {
          width: 20px;
          text-align: center;
          font-size: 14px;
        }
      `}</style>
    </aside>
  );
}
